import { MRT_ColumnDef } from "material-react-table"
import { useMemo, useState, } from "react"
import { ReporteCompra, } from "../types/reporte-compra.interface"
import { Button, Chip } from "@mui/material"
import { toast } from "react-toastify"
import { cellNotFilter, emptyCellObject, formatNestedDateWithTimeCell } from "@/shared"
import { openGenericObjectModalAsync } from "@/shared/components/ui/ModalGenericObject/useGenericObjectModalStore"
import {  getOrdenesCompras } from "@/shared/actions/erp"
import { OpenInNew } from "@mui/icons-material"
import { fieldOrdenCompra } from "@/shared/utils/fields-modal-generic-object"


export default function useTableColumnsReporteCompra() {

  const [details, setDetails] = useState<{ series: string }[]>([])
  const [isOpenModal, setIsOpenModal] = useState(false)
  //console.log('details', details)
  const onDetails = (e: ReporteCompra) => {
    if (!e.series?.length) return toast.error('No existe series para este producto.')

    const formattedSerie = e.series.map((s) => ({ series: s }))

    setIsOpenModal(true)
    setDetails(formattedSerie)
  }
  const columnsReporteCompra = useMemo<MRT_ColumnDef<ReporteCompra>[]>(
    () => [
      {
        ...cellNotFilter,
        accessorKey: 'ingreso.fecha_creacion',
        header: 'Fecha Ingreso',
        Cell: ({ row }) => formatNestedDateWithTimeCell(row, 'ingreso.fecha_creacion')
      },
      {
        id: 'orden_compra_codigo',
        accessorKey: 'orden_compra.codigo',
        header: 'Orden Compra',
        Cell: ({ row }) => {
          const base = row.original;

          return <Button
            variant="text"
            endIcon={<OpenInNew />}
            onClick={() => {
              openGenericObjectModalAsync({
                fetcher: async () => {
                  const resp = await getOrdenesCompras({
                    codigo: base.orden_compra?.codigo
                  })
                  return resp.data.data[0]
                },
                fields: fieldOrdenCompra,
                title: "🏷️ Orden de Compra",
                emptyFallback: "—",
              });

            }}
          >
            {base.orden_compra.codigo}
          </Button>
        }
      },
      {
        accessorKey: 'ingreso.numero_factura',
        header: 'N° Factura',
        Cell: ({ row }) => emptyCellObject(row.original?.ingreso, 'numero_factura')
      },
      {
        accessorKey: 'ingreso.numero_guia_remision',
        header: 'Guía Remisión',
        Cell: ({ row }) => emptyCellObject(row.original?.ingreso, 'numero_guia_remision')
      },
      {
        //...cellNotFilter,
        id: 'razon_social_proveedor',
        accessorKey: 'proveedor.razon_social',
        header: 'Proveedor',
        Cell: ({ row }) => emptyCellObject(row.original?.proveedor, 'razon_social')
      },
      {
        //...cellNotFilter,
        id: 'descripcion_producto',
        accessorKey: 'producto.descripcion',
        header: 'Producto',
        size: 140,
        Cell: ({ row }) => emptyCellObject(row.original?.producto, 'descripcion')
      },
      //{
      //  ...cellNotFilter,
      //  accessorKey: 'presentacion',
      //  header: 'Presentacion',
      //  size: 140,
      //  Cell: ({ row }) => renderEmpty(row.original?.producto?.presentacion)
      //},
      //{
      //  ...cellNotFilter,
      //  accessorKey: 'producto.metros_base',
      //  header: 'Metros base',
      //  Cell:({row})=>renderEmpty(row.original?.producto?.metros_base)
      //},
      //{
      //  ...cellNotFilter,
      //  accessorKey: 'producto.usa_metros',
      //  header: 'Factor Conversion',
      //  Cell:({row})=>{
      //    const es_usa_metros = row.original?.producto?.usa_metros ?? false
      //    return es_usa_metros ? `${row.original?.producto?.metros_actuales}(metros)`:row.original?.producto?.stock_actual
      //  }
      //},
      {
        ...cellNotFilter,
        accessorKey: 'cantidad',
        header: 'Cant. Recebida',
        Cell: ({ row }) => emptyCellObject(row.original, 'cantidad')
      },

      {
        ...cellNotFilter,
        accessorKey: 'cantidad_esperada',
        header: 'Cant. Solicitada',
        Cell: ({ row }) => {
          return <Chip 
          variant="outlined"
          color="info"
          label={emptyCellObject(row.original, 'cantidad_aprobada')} />
        }
      },
      {
        ...cellNotFilter,
        accessorKey: 'precio_compra',
        header: 'Precio Unitario (USD)',
        Cell: ({ row }) => emptyCellObject(row.original, 'precio_compra')
      },
      {
        ...cellNotFilter,
        accessorKey: 'ultimo_precio_compra',
        header: 'Ultimo Precio Compra (USD)',
        Cell: ({ row }) => emptyCellObject(row.original, 'ultimo_precio_compra')
      },
      {
        ...cellNotFilter,
        accessorKey: 'orden_compra.total_precio_compra',
        header: 'Total (USD)',
        Cell: ({ row }) => emptyCellObject(row?.original, 'total_precio_compra')
      },
      {
        ...cellNotFilter,
        accessorKey: 'serie_1',
        header: 'Serie',
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              size="small"
              onClick={() => {
                onDetails(row.original)
              }}
              disabled={!row.original.series?.length}
            >
              {row.original.series?.length
                ? `SERIES (${row.original.series.length})` : 'SIN SERIES'}
            </Button>
          )
        }
      },


    ], []
  )
  const columnsSeries = useMemo<MRT_ColumnDef<{ series: string }>[]>(
    () => [
      {
        header: "#", // encabezado de la columna
        Cell: ({ row }) => row?.index + 1, // row.index empieza en 0
        size: 40,
      },
      {
        accessorKey: 'series',
        header: 'Serie'
      }
    ], []
  )
  return {
    columnsReporteCompra,
    columnsSeries,
    isOpenModal, setIsOpenModal,
    details
  }
}